<div class="update-msg">
    <div class="update-msg-wrapper">
        <p class="mb-0"> 
            {{ bannerMsg | translate }}
        </p>
        <button class="close ml-auto" [attr.aria-label]="'TEACHER.CREATE_ACCESS.UPDATE_CONTENTS_BANNER.SCREEN_READER.CLOSE' | translate" qid="closeBanner" (click)="closeBanner()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>